import { Component, OnInit, ChangeDetectorRef } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Subscription } from "rxjs";
import { CommonService } from "src/app/core/services/common.service";
import { PermissionService } from "src/app/core/services/permisson.service";
import { UserService } from "src/app/core/services/user.service";
import { PLReportService } from "src/app/core/services/system.service";
import {
  componentsSideMenuOptions,
  defaultRole,
  DefaultSideBar,
  landingPageUrl,
} from "src/app/models/sidenav";
import {
  adspPfmMenus,
  AGN_ADV_LVL_ROLES,
  AGN_LVL_ROLES,
  bdspPfmMenus,
  NON_API_ADV_ROLES,
  READ_ONLY_ROLES,
  SUB_PATH,
  tdspPfmMenus,
  vdspPfmMenus,
} from "src/app/models/common";
import {
  platFormLevelMenu,
  agencyLevelMenu,
  advertiserLevelMenu,
} from "src/app/models/sidebar";
import { SystemService } from "src/app/core/services/system.service";
import { AppConfig } from "src/app/configs/app.config";
import { MGN_SERVE_ROLES } from "src/app/models/common";

@Component({
  selector: "dmp-sidebar",
  templateUrl: "./sidebar.component.html",
  styleUrls: ["./sidebar.component.scss"],
})
export class SidebarComponent implements OnInit {
  subscription: Subscription;
  sideMenu: string = "main_menu";
  suboptionSelected: string;
  defaultRole = defaultRole;
  landingPageUrl = landingPageUrl;

  platFormLevelMenu = platFormLevelMenu;
  agencyLevelMenu = agencyLevelMenu;
  advertiserLevelMenu = advertiserLevelMenu;

  role: string;
  agency_id;
  agency_advertiser_id;
  advertiser_id;
  platformRole: boolean = false;
  isClientPoliticalBoolean: boolean;
  isPLReportUser: boolean = false;
  subMenuOptions = [];
  selectedTab: string;
  selectedOptionsGroup: string;
  selectedPlatformType: string;
  selectedEntityGroup: string;
  componentName: string;
  componentId: string;
  componentContent: any = null;
  accountStatementViewPermission;
  defaultSideBar: DefaultSideBar;

  apnx_enabled: boolean;
  adsp_enabled: boolean;
  bdsp_enabled: boolean;
  tdspEnabled: boolean;
  cdp_enabled: boolean = false;
  user_cdp_enabled: boolean = false;
  agc_cdp_enabled: boolean = false;
  offline_attribution_enabled: boolean;
  adsp_regions: Array<any>;
  readOnlyRole = new Set<any>();

  subPath = SUB_PATH;
  instance: string;
  routeParamsObj;

  dspTypes = {};
  offlineAttributeItem: Set<String> = new Set(["coupon_code"]);
  plfLibrariesGrp: Set<String> = new Set([
    "libraries",
    "adsp_libraries_us",
    "adsp_libraries_eu",
    "bdsp_librares",
    "tdsp_libraries",
  ]);
  pLReportGrp: Set<String> = new Set([
    "vdsp_reports",
    "adsp_reports_us",
    "adsp_reports_eu",
    "bdsp_reports",
    "tdsp_reports",
  ]);
  agencyReportAnalyticsGrp: Set<String> = new Set([
    "reports",
    "adsp_reports",
    "analytics",
    "bdsp_reports",
    "tdsp_reports",
  ]);
  agencyReportsGrp: Set<String> = new Set([
    "reports",
    "adsp_reports",
    "bdsp_reports",
    "tdsp_reports",
  ]);
  campaignMenus: Set<String> = new Set([
    "Campaigns",
    "Insertion Orders",
    "Line Items",
  ]);
  clientDealViewPrm = "deal_client_view";
  filterSubMenu: Array<any> = [];

  roleWithPfmMenuBackAllowed: Set<String> = new Set([
    "platform_superadmin",
    "platform_admin",
    "account_manager",
    "finance_user",
  ]);

  roleWithAdvMenuBackAllowed: Set<String> = new Set([
    "platform_superadmin",
    "platform_admin",
    "account_manager",
    "agency_primary_admin",
    "agency_admin",
    "agency_user",
    "agency_reporting_user",
    "managed_agency_user",
    "finance_user",
    "self_read_only_agc_user",
  ]);
  readonly whiteLabelMode: boolean;
  readonly supportedDSPs: Set<string>;

  public readonly BASE_CDP_V2_URL: string = AppConfig.BASE_CDP_V2_URL;
  cdpAllowed: boolean = AppConfig.IS_CDP_ALLOWED;

  constructor(
    private route: ActivatedRoute,
    public router: Router,
    private commonService: CommonService,
    private permissionService: PermissionService,
    private userService: UserService,
    private pLReportService: PLReportService,
    private activatedRoute: ActivatedRoute,
    private systemService: SystemService,
    private changeDetector: ChangeDetectorRef
  ) {
    this.defaultSideBar = new DefaultSideBar();
    commonService.changeViewFromComponent$.subscribe((item) => {
      commonService.changeReportStatus(true);
      this.changeToSecondarySubMenu(item);
    });

    this.subscription = commonService.getMenuFlag().subscribe((flag) => {
      // menu change main / platform / advertiser
      commonService.changeReportStatus(true);
      // console.log('menu flag >> ', flag)
      this.getSideBarContent(flag);
      // flag ? this.changeToSecondaryMenu() : this.changeToMainMenu();
    });

    commonService.changeContentFromComponent.subscribe((data) => {
      this.componentContent = data;
    });

    commonService.changeSecondarySubMenu.subscribe((data) => {
      data.sideBarStatus.forEach((value) => {
        this.subMenuOptions.forEach((option) => {
          if (value.id == option.id) {
            option.active = value.status;
          }
        });
      });
    });

    this.whiteLabelMode = AppConfig.WHITE_LABEL_MODE;
    this.supportedDSPs = AppConfig.SUPPORTED_DSPS;
  }

  ngOnInit(): void {
    this.role = localStorage.getItem("role");
    this.user_cdp_enabled = localStorage.getItem("user_cdp_enabled") == "true";
    if (localStorage.getItem("clientPermissions")) {
      this.accountStatementViewPermission =
        this.permissionService.getClientPermission("show_account_statement");
    } else this.accountStatementViewPermission = true;

    if (
      this.role == "platform_superadmin" ||
      this.role == "platform_admin" ||
      this.role == "account_manager"
    ) {
      this.platformRole = true;
    }
    if (this.role == "platform_superadmin") {
      this.checkPLReportPerm();
    }
    this.getSystemInfo();
    this.readOnlyRole = READ_ONLY_ROLES;
  }

  getSystemInfo() {
    this.systemService.getInstanceDetails().subscribe((res) => {
      this.instance = res.is_self_signup_supported ? "live" : "live-uk";
      if (!res.is_self_signup_supported || AppConfig.WHITE_LABEL_MODE) {
        if (AppConfig.WHITE_LABEL_MODE) {
          this.filterSubMenu.length = 0;
          if (!this.supportedDSPs.has('vizibl_dsp')) {
            this.filterSubMenu.push(...vdspPfmMenus);
          }
          if (!this.supportedDSPs.has('amazon_dsp')) {
            this.filterSubMenu.push(...adspPfmMenus);
          }
          if (!this.supportedDSPs.has('beeswax_dsp')) {
            this.filterSubMenu.push(...bdspPfmMenus);
          }
          if (!this.supportedDSPs.has('trade_desk_dsp')) {
            this.filterSubMenu.push(...tdspPfmMenus);
          }
        }
        this.platFormLevelMenu.forEach((menu) => {
          if (menu.children) {
            for (let index = menu.children.length - 1; index >= 0; index--) {
              const subMenu = menu.children[index];
              if (this.filterSubMenu.includes(subMenu.group)) {
                menu.children.splice(index, 1);
              }
            }
          }
        });
      }
    });
  }

  ngAfterContentChecked(): void {
    this.changeDetector.detectChanges();
  }

  isDspDisabled(dspType: string): boolean {
    const dspKeyMap: Record<string, string> = {
      vdsp: "apnx_enabled",
      adsp_us: "adsp_us_region",
      adsp_eu: "adsp_uk_region",
      bdsp: "bdsp_enabled",
      tdsp: "tdsp_enabled",
    };

    const key = dspKeyMap[dspType];
    return key ? localStorage.getItem(key) === "false" : false;
  }

  getToolTip(dspType: string) {
    if (dspType == "vdsp" && localStorage.getItem("apnx_enabled") == "false") {
      return "You do not have access to the Global section - Old of Campaign Management & Reporting. Please contact the Agency Primary Admin for assistance.";
    } else if (
      dspType == "tdsp" &&
      localStorage.getItem("tdsp_enabled") == "false"
    ) {
      return "You do not have access to the Global section of Campaign Management & Reporting. Please contact the Agency Primary Admin for assistance.";
    } else if (
      dspType == "adsp_us" &&
      localStorage.getItem("adsp_us_region") == "false"
    ) {
      return "You do not have access to the US Amazon section of Campaign Management & Reporting. Please contact the Agency Primary Admin for assistance.";
    } else if (
      dspType == "adsp_eu" &&
      localStorage.getItem("adsp_uk_region") == "false"
    ) {
      return "You do not have access to the EU Amazon section of Campaign Management & Reporting. Please contact the Agency Primary Admin for assistance.";
    } else if (
      dspType == "bdsp" &&
      localStorage.getItem("bdsp_enabled") == "false"
    ) {
      return "You do not have access to the Sensitive Categories section of Campaign Management & Reporting. Please contact the Agency Primary Admin for assistance.";
    }
  }

  getSideBarContent(flag) {
    if (
      this.sideMenu == "main_menu" ||
      this.sideMenu == "platform_menu" ||
      this.sideMenu == "advertiser_menu" ||
      this.sideMenu == "option_menu"
    ) {
      let params = {};
      params["component"] = "all";
      params = { ...params, ...this.getparams() };
      this.userService.getClientSettingData(params).subscribe((res) => {
        this.defaultSideBar = res.data;
        this.changeMenu(flag);
      });
    } else {
      this.changeMenu(flag);
    }
    this.getPoliticalDetails();
  }

  isClientPolitical() {
    return this.isClientPoliticalBoolean;
  }

  advertiserMenuBackAllowed() {
    return this.roleWithAdvMenuBackAllowed.has(this.role);
  }

  platformMenuBackAllowed() {
    return this.roleWithPfmMenuBackAllowed.has(this.role);
  }

  advertiserMenuBackAction() {
    if (this.getSavedAdvertiser()) {
      this.router.navigate([`/advertiser/`]);
      this.selectedOptionsGroup = "advertiser";
      // this.changeMenu('main_menu');
    }
    if (this.getSavedAgencyAdvertiser()) {
      let currentUrl = this.router.url;
      let dsp = this.router.url.split("?")[0].split("/")[1];
      let redirect = this.subPath.includes(dsp)
        ? `/${dsp}/agency-advertiser/`
        : "/agency-advertiser/";
      this.router.navigate([redirect], {
        queryParams: {
          agency_id: localStorage.getItem("agency_id"),
          adsp_region:
            this.route.snapshot.queryParamMap.get("adsp_region") ?? null,
        },
      });
      this.selectedOptionsGroup == "agency_advertisers";
      // this.changeMenu('platform_menu');
    }
  }

  getparams() {
    let params = {};
    if (this.getSavedAdvertiser()) {
      params["advertiser_id"] = this.getSavedAdvertiser();
    }
    if (this.getSavedAgencyAdvertiser()) {
      params["agency_advertiser_id"] = this.getSavedAgencyAdvertiser();
    } else if (this.getSavedAgency()) {
      params["agency_id"] = this.getSavedAgency();
    }
    return params;
  }

  getViewReportId(dspKey: string, isPlReport: boolean): string | null {
    const keyPrefix = "latest_unsaved_";
    const keySuffix = isPlReport ? "_view_pl_report" : "_view_report";

    // VDSP does not use dspType in the key
    const storageKey =
      dspKey === "vdsp"
        ? `${keyPrefix}${keySuffix.slice(1)}`
        : `${keyPrefix}${dspKey}${keySuffix}`;

    return localStorage.getItem(storageKey);
  }

  routeToViewReport(dspType = "vdsp", isPlReport = false) {
    let report_id;
    let region = null;

    report_id = this.getViewReportId(dspType, isPlReport);

    if (report_id) {
      if (dspType == "adsp_us" || dspType == "adsp_eu") {
        region = dspType.split("_")[1].toUpperCase();
        dspType = "adsp";
      }

      this.suboptionSelected =
        dspType == "vdsp" ? "view_report" : `${dspType}_view_report`;
      let path =
        dspType != "vdsp"
          ? `/${dspType}/report/${report_id}/view`
          : `/report/${report_id}/view/`;

      this.router.navigate([path], {
        queryParams: { ...this.getparams(), adsp_region: region },
      });
    }
  }

  accessViewReport(type, isPlReport = false) {
    return !this.getViewReportId(type, isPlReport);
  }

  routeURL(item, params = null) {
    let queryParams = this.getparams();
    if (params) {
      queryParams["adsp_region"] = params;
    }
    this.router.navigate([item.routes], {
      queryParams: queryParams,
      // state: { sideMenu: this.sideMenu }
    });
  }

  checkPLReportPerm() {
    this.pLReportService.checkUserPlReportAccess().subscribe(
      (res) => {},
      (err) => {
        this.isPLReportUser = false;
      },
      () => {
        this.isPLReportUser = true;
      }
    );
  }

  getListPermission(component) {
    if (this.clientDealViewPrm == component && MGN_SERVE_ROLES.has(this.role)) {
      return false; // If menu group is deal && role is managed serve users role hide it.
    }
    return this.permissionService.getListPermissions(component);
  }

  getViewPermission(component) {
    return this.permissionService.getViewPermissions(component);
  }

  checkPlfLibPms() {
    return this.role != "platform_account_user";
  }

  checkPLReportPms() {
    return this.isPLReportUser;
  }

  checkAgcReportsPms(item) {
    if (this.agencyReportsGrp.has(item.group)) {
      return (
        this.getListPermission(item.listPer) &&
        this.role != "platform_account_user"
      );
    } else {
      return (
        this.getViewPermission(item.viewPer) &&
        this.role != "platform_account_user" &&
        !this.platformRole
      );
    }
  }

  getAdvertiserGroupListPermission(menuOption) {
    if (menuOption.entity == "campaign") {
      return (
        this.getListPermission(menuOption.listPer) &&
        this.defaultSideBar[menuOption.entity].view
      );
    } else if (menuOption.entity == "reports") {
      return (
        this.getListPermission(menuOption.listPer) &&
        this.role != "platform_account_user"
      );
    } else if (menuOption.entity == "analytics") {
      return (
        this.role != "platform_account_user" &&
        !this.platformRole &&
        this.getViewPermission(menuOption.viewPer) &&
        !this.getSavedAgencyAdvertiser()
      );
    } else if (this.offlineAttributeItem.has(menuOption.entity)) {
      return (
        this.getListPermission(menuOption.listPer) &&
        this.offline_attribution_enabled &&
        !this.readOnlyRole.has(this.role)
      );
    } else {
      return this.getListPermission(menuOption.listPer);
    }
  }

  getNavLink(menuOption, entity) {
    if (entity == "inventory_list") {
      return this.defaultSideBar[entity].view
        ? menuOption.navLink
        : menuOption.navLinkTwo;
    } else {
      return menuOption.navLink;
    }
  }

  getAdvertiserListPermission(subMenu) {
    if (subMenu.isPlatformEntity) {
      if (
        subMenu.entity == "inventory_list" ||
        subMenu.entity == "custom_location"
      ) {
        return (
          (this.getSavedAdvertiser()
            ? this.getListPermission(subMenu.advLstPrm)
            : this.getListPermission(subMenu.agAdvLstPrm)) &&
          this.defaultSideBar[subMenu.entity].view
        );
      } else if (subMenu.entity == "deals") {
        return (
          !this.getSavedAgencyAdvertiser() &&
          this.getListPermission(subMenu.advLstPrm) &&
          this.getListPermission(subMenu.listPer)
        );
      } else {
        return this.getSavedAdvertiser()
          ? this.getListPermission(subMenu.advLstPrm)
          : this.getListPermission(subMenu.agAdvLstPrm);
      }
    } else if (subMenu.entity == "analytics") {
      return (
        this.role != "platform_account_user" &&
        !this.platformRole &&
        this.getViewPermission(subMenu.viewPer) &&
        !this.getSavedAgencyAdvertiser()
      );
    } else {
      return this.getListPermission(subMenu.listPer);
    }
  }

  isClientWithPerm(menu) {
    if (
      MGN_SERVE_ROLES.has(this.role) &&
      (menu.entity == "account_statement" || menu.entity == "users")
    ) {
      return false; // Disable My accounts and users for Managaged Users.
    }
    if (menu.entity == "account_statement") {
      return (
        this.getViewPermission(menu.viewPer) &&
        this.accountStatementViewPermission
      );
    } else {
      if (menu.name == "Campaign Management & Reporting") {
        return (
          this.getListPermission(menu.listPer) ||
          this.getListPermission("report")
        );
      }
      return this.getListPermission(menu.listPer);
    }
  }

  getVDSPLibraryLastMenu(menu, subMenu) {
    if (menu.dspType == "vdsp") {
      if (subMenu.entiy == "deals") {
        return this.defaultSideBar.custom_location.view;
      } else if (subMenu.entity == "custom_location") {
        return !this.defaultSideBar.custom_location.view;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  changeMenu(flag) {
    this.sideMenu = flag.menu;
    if (this.sideMenu == "main_menu") {
      localStorage.removeItem("agency_id");
    }
    if (this.sideMenu == "platform_menu") {
      localStorage.setItem("agency_id", this.getSavedAgency());
    }
    this.selectedOptionsGroup = flag.optionGroup;
    this.suboptionSelected = flag.optionSubGroup;
    this.selectedPlatformType = flag.platformType;
    this.selectedEntityGroup = flag.entityGroup;
  }

  changeToSecondarySubMenu(item) {
    this.changeMenu({ menu: "option_menu" });
    this.subMenuOptions = componentsSideMenuOptions[item.component];
    this.componentId = item.component;
    this.selectedTab = item.selectedTab;
    this.componentName = item.componentName;
    this.getPoliticalDetails();
  }

  checkEnabledDSP() {
    this.dspTypes = {
      vdsp: this.apnx_enabled,
      adsp_us: this.adsp_enabled && this.adsp_regions.includes("US"),
      adsp_eu: this.adsp_enabled && this.adsp_regions.includes("EU"),
      bdsp: this.bdsp_enabled,
      tdsp: this.tdspEnabled,
      nonDSP: true,
    };
  }

  getPoliticalDetails() {
    this.agency_id = this.route.snapshot.queryParamMap.get("agency_id");
    this.agency_advertiser_id = this.activatedRoute.snapshot.queryParamMap.get(
      "agency_advertiser_id"
    );
    this.advertiser_id = this.route.snapshot.queryParamMap.get("advertiser_id");
    if (this.agency_id || this.agency_advertiser_id || this.advertiser_id) {
      this.permissionService
        .getConfig(
          this.agency_id
            ? this.agency_id
            : this.agency_advertiser_id
            ? this.agency_advertiser_id
            : this.advertiser_id,
          this.agency_id
            ? "agency"
            : this.agency_advertiser_id
            ? "agency-advertiser"
            : "advertiser"
        )
        .subscribe(
          (res) => {
            this.isClientPoliticalBoolean =
              res.data.vertical == "political" ? true : false;
            this.apnx_enabled = res.data.apnx_enabled;
            this.adsp_enabled = res.data.adsp_enabled;
            this.bdsp_enabled = res.data.bdsp_enabled;
            this.tdspEnabled = res.data.tdsp_enabled;
            this.adsp_regions = res.data.adsp_regions;
            this.cdp_enabled = res.data.cdp_enabled;
            this.offline_attribution_enabled =
              res.data.enable_offline_attribution;
            this.agc_cdp_enabled = res.data.agc_cdp_enabled || false;
          },
          (err) => {},
          () => {
            this.checkEnabledDSP();
          }
        );
    }
  }

  checkCdpPer() {
    if (this.getSavedAdvertiser()) {
      return this.cdp_enabled && this.user_cdp_enabled && this.cdpAllowed;
    }
    if (this.getSavedAgencyAdvertiser()) {
      return (
        this.cdp_enabled &&
        this.user_cdp_enabled &&
        this.agc_cdp_enabled &&
        this.cdpAllowed
      );
    }
  }

  getSavedAdvertiser() {
    let advertiser_id = this.route.snapshot.queryParamMap.get("advertiser_id");
    if (advertiser_id) return advertiser_id;
    return localStorage.getItem("advertiser_id");
  }

  getSavedAgency() {
    let agency_id = this.route.snapshot.queryParamMap.get("agency_id");
    if (agency_id) return agency_id;
    return localStorage.getItem("agency_id");
  }

  getSavedAgencyAdvertiser() {
    let agency_advertiser_id = this.route.snapshot.queryParamMap.get(
      "agency_advertiser_id"
    );
    if (agency_advertiser_id) return agency_advertiser_id;
    return localStorage.getItem("agency_advertiser");
  }

  selectedTabFromSubMenu(item) {
    this.selectedTab = item.id;
    this.commonService.changeStepFromSideMenu(item.id);
    this.commonService.contentFromSideMenu(this.componentContent);
  }

  isAdspPath() {
    return this.router.url.split("?")[0].split("/")[1];
  }

  getMenuNavLink(menu) {
    let subPath = "";
    const getDspPath = (
      tdsp: string | boolean,
      apnx: string | boolean,
      adsp: string | boolean,
      bdsp: string | boolean,
    ): string => {
      if (tdsp === true || tdsp === "true") return "/tdsp";
      if (apnx === true || apnx === "true") return "";
      if (adsp === true || adsp === "true") return "/adsp";
      if (bdsp === true || bdsp === "true") return "/bdsp";
      return "";
    };
    if (menu.entityGroup == "all") {
      if (this.role != "managed_agency_user") {
        subPath = getDspPath(
          this.tdspEnabled,
          this.apnx_enabled,
          this.adsp_enabled,
          this.bdsp_enabled,
        );
      } else {
        subPath = getDspPath(
          localStorage.getItem("tdsp_enabled"),
          localStorage.getItem("apnx_enabled"),
          localStorage.getItem("adsp_us_region") === "true" ||
            localStorage.getItem("adsp_uk_region") === "true",
          localStorage.getItem("bdsp_enabled"),
        );
      }
    }
    return this.role.includes("report")
      ? subPath + menu.reportNavLink
      : this.defaultSideBar.insertion_order.view
      ? subPath + menu.navLink
      : subPath + menu.LiteNavLink;
  }

  getPlatFormType() {
    return this.apnx_enabled
      ? "vdsp"
      : this.adsp_enabled
      ? "adsp"
      : this.bdsp_enabled
      ? "bdsp"
      : this.tdspEnabled
      ? "tdsp"
      : "";
  }

  getGroup(menu, level) {
    if (level === "agency") return "agency_advertisers";

    const dspTypeMap: Record<string, string> = {
      vdsp: "vdsp",
      tdsp: "tdsp",
      adsp_eu: "adsp",
      adsp_us: "adsp",
      bdsp: "bdsp",
    };

    const base = dspTypeMap[menu.dspType];
    if (!base) return "political";

    if (this.role.includes("report")) {
      return base === "vdsp" ? "reports" : `${base}_reports`;
    }

    return this.defaultSideBar.insertion_order.view
      ? base === "vdsp"
        ? "campaigns"
        : `${base}_campaigns`
      : "political";
  }

  getAdspRegion() {
    if (this.role != "managed_agency_user") {
      if (!this.apnx_enabled && this.adsp_enabled) {
        return this.adsp_regions.includes("US") ? "US" : "EU";
      }
    } else {
      if (
        localStorage.getItem("apnx_enabled") == "false" &&
        (localStorage.getItem("adsp_us_region") == "true" ||
          localStorage.getItem("adsp_uk_region") == "true")
      ) {
        return localStorage.getItem("adsp_us_region") == "true" ? "US" : "EU";
      }
    }
    return null;
  }

  selectCategoryOptions(
    item: string = null,
    route?,
    PlatformType?,
    navigate = true,
    adsp_params = null,
    entityGroup?,
    isThirdHierarchy = false,
    isCdp = false
  ) {
    if (item) {
      this.selectedOptionsGroup =
        this.selectedOptionsGroup == item ? null : item;
      if (!isThirdHierarchy) {
        this.selectedPlatformType =
          this.selectedPlatformType == PlatformType ? null : PlatformType;
      }
    }
    if (isCdp) {
      let token = localStorage.getItem("token");
      let refresh = localStorage.getItem("refresh");
      let url = `${this.BASE_CDP_V2_URL}handler?token=${encodeURIComponent(
        token
      )}&refresh=${encodeURIComponent(refresh)}
        &role=${this.role}&name=${localStorage.getItem("first_name")}`;
      if ([...AGN_LVL_ROLES].includes(this.role)) {
        url += `&agency_id=${this.agency_id}`;
      } else if ([...NON_API_ADV_ROLES].includes(this.role)) {
        url += `&advertiser_id=${this.advertiser_id}`;
      } else if ([...AGN_ADV_LVL_ROLES].includes(this.role)) {
        url += `&advertiser_id=${this.agency_advertiser_id}`;
      }
      url += `&instance=${this.instance}`;
      window.open(url, "_blank")?.focus();
      return;
    }
    if (route && navigate) {
      //if u r in difftab and close will redirect and open again
      this.routeURL({ routes: route }, adsp_params);
    }
    if (item && !PlatformType) {
      //to close other dropdown if other is opend
      this.selectedPlatformType = null;
    }
    if (item && !entityGroup) {
      this.selectedEntityGroup = null;
    }
    if (!PlatformType && !entityGroup) {
      this.selectedEntityGroup = "all";
    }
    if (!item) {
      this.selectedPlatformType =
        this.selectedPlatformType == PlatformType ? null : PlatformType;
      this.selectedEntityGroup =
        this.selectedEntityGroup == entityGroup ? null : entityGroup;
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
